module.exports = __webpack_public_path__ + "img/pattern.5da5ad58.png";